export default __webpack_public_path__ + "static/media/bottomArrow.244352ed.svg";